import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'sa-lohi-preload-status',
  templateUrl: './lohi-preload-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LohiPreloadStatusComponent {
  @Input() public order: { loHiPreloadPaused: boolean; loHiPreloadActive: boolean };
  constructor() {}
}
